import { render, staticRenderFns } from "./danger.vue?vue&type=template&id=7ff4354e&scoped=true"
import script from "./danger.vue?vue&type=script&lang=js"
export * from "./danger.vue?vue&type=script&lang=js"
import style0 from "./danger.vue?vue&type=style&index=0&id=7ff4354e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_j7fuxwmg3pjjrof4ryv5g7uhre/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff4354e",
  null
  
)

export default component.exports